import styled from 'styled-components';
import { fontColorMixin } from '../../mixins/fontColorMixin';
export var StyledZillowHomeLogo = /*#__PURE__*/styled.svg.withConfig({
  displayName: "StyledZillowHomeLogo",
  componentId: "c11n-8-111-1__sc-1hmwaqs-0"
})(["", ""], fontColorMixin);